export var AuditLogActions;
(function (AuditLogActions) {
    AuditLogActions["PUT"] = "PUT";
    AuditLogActions["POST"] = "POST";
    AuditLogActions["PATCH"] = "PATCH";
    AuditLogActions["DELETE"] = "DELETE";
    AuditLogActions["VIEW"] = "VIEW";
    AuditLogActions["CREATE"] = "CREATE";
    AuditLogActions["UPDATE"] = "UPDATE";
    AuditLogActions["ACTIVATE"] = "ACTIVATE";
    AuditLogActions["DEACTIVATE"] = "DEACTIVATE";
})(AuditLogActions || (AuditLogActions = {}));
//# sourceMappingURL=audit-log-actions.js.map